export const copy = {
  it: {
    nav: {
      tech: "Tecnologia",
      lines: "Linee",
      alarm: "Allarme",
      verification: "Verifica",
      lifecycle: "Ciclo di vita",
      contact: "Contatto",
      cta: "Richiedi brief",
      coords: "45.4642° N — 09.1900° E",
    },
    hero: {
      overline: "Sistema di protezione passiva anti-drone // PRFV",
      line1: "SHADOW",
      line2: "SHIELD",
      sub: "Pali e reti in fibra di vetro. Invisibile alla vista, al termico e ai radar: la barriera fisica che i droni ostili non vedono arrivare.",
      stats: [
        { v: "0%", l: "Riflesso speculare" },
        { v: "25–30", l: "Anni di vita utile" },
        { v: "−90%", l: "Costi di manutenzione" },
        { v: "<15s", l: "Decollo drone di pattuglia" },
      ],
      scroll: "Scorri per il brief",
    },
    marquee: "// SHADOW SHIELD // BARRIERA STEALTH IN PRFV // INVISIBILITÀ TERMICA // RADIOTRASPARENTE // ATEX SPARK-FREE // ALLARME A FIBRA OTTICA ",
    stealth: {
      index: "[01]",
      title: "Tecnologia Stealth",
      lead: "Ogni componente è progettato per scomparire: nero opaco nella massa, assorbimento del vicino infrarosso, zero metallo.",
      image_caption: "Pultruso PRFV Ø 100 mm — finitura ruvida anti-riflesso",
      features: [
        { t: "Pigmentazione integrale", d: "Nero opaco / Grigio Antracite RAL 7016 miscelato nella resina prima della pultrusione. Zero verniciatura, glint azzerato al 100%." },
        { t: "Assorbimento NIR", d: "Additivi nanostrutturati assorbono gli illuminatori notturni dei droni (850–940 nm) senza rifletterli." },
        { t: "Invisibilità termica", d: "Bassissima inerzia termica: la struttura segue la temperatura dell'aria ed elimina il contrasto nei visori FLIR." },
        { t: "Zero metallo", d: "Bulloneria e giunti in Nylon rinforzato o Kevlar. Nessun componente riflettente o conduttivo." },
      ],
    },
    lines: {
      index: "[02]",
      title: "Tre linee, un sistema",
      lead: "Configurazioni mirate per ogni asset critico — non una recinzione generica.",
      items: [
        { tag: "Linea 1", t: "Gabbia 3D — Fabbricati & depositi", img: "/images/line1_cage.png", specs: ["Stand-off 5 m per dissipare l'onda d'urto", "Doppia rete: 40×40 mm sacrificale + 10×10 mm contenimento", "Soffitto inclinato 15° per deflusso meteorico", "Stop a droni FPV kamikaze su cisterne e fabbricati"] },
        { tag: "Linea 2", t: "Corona radar — Antenne & TLC", img: "/images/line2_radar.png", specs: ["Radiotrasparenza totale: 100% amagnetica e dielettrica", "Altezza 6–10 m, recinzione a corona circolare", "Maglia 25×25 mm a filo continuo, RCS minima", "Nessun eco fantasma sui lobi di radiazione"] },
        { tag: "Linea 3", t: "Barriera lineare — Strade & viadotti", img: "/images/line3_highway.png", specs: ["Braccio a sbalzo a L inclinato 45° verso l'esterno", "Ancoraggio su barriere New Jersey, zero scavi", "Maglia 30×30 mm anti-vento, basso effetto vela", "Invisibile nei coni d'ombra dell'illuminazione stradale"] },
      ],
    },
    alarm: {
      index: "[03]",
      title: "Allarme a fibra ottica invisibile",
      lead: "Un cavo sensore da 1,8–2,2 mm intrecciato nella rete rileva taglio, sollevamento e impatto — senza compromettere lo stealth.",
      points: [
        { t: "Localizzazione ± 5 m", d: "Analizzatore OTDR/APASS converte micro-deformazioni in coordinate precise sulla mappa GIS." },
        { t: "Immunità elettromagnetica", d: "Fibra dielettrica: nessuna interferenza con radar e campi EM." },
        { t: "Integrazione VMS", d: "ONVIF Profile M / SDK nativo: Milestone, Genetec, Avigilon. Slewing automatico delle PTZ termiche." },
        { t: "Contromisura automatica", d: "Notifica MAVLink/REST a stazione Drone-in-a-Box: decollo in meno di 15 secondi e tracciamento termico dell'intruso." },
      ],
    },
    verification: {
      index: "[04]",
      title: "Verifica tecnica",
      lead: "Analisi indipendente dei calcoli strutturali del documento preliminare (vento di progetto 750 N/m² ≈ 125 km/h, interasse pali 4 m).",
      table_head: ["Altezza", "Carico base", "Momento max", "Freccia in cima", "Stato"],
      table_rows: [
        ["4 m — Strade", "≈ 4.560 N", "9.120 Nm", "≈ 4,2 cm", "Stabile, autoportante"],
        ["6 m — Radar", "≈ 6.840 N", "20.520 Nm", "≈ 21,3 cm", "Al limite: richiede irrigidimento"],
        ["8 m — Gabbie", "≈ 9.120 N", "36.480 Nm", "≈ 67,5 cm", "Instabile senza telaio chiuso"],
      ],
      strengths_t: "Punti di forza",
      strengths: [
        "Calcoli internamente coerenti: carichi, momenti e frecce matematicamente consistenti.",
        "Segmentazione per asset: tre configurazioni mirate invece di una soluzione generica.",
        "Vantaggi intrinseci del PRFV: radiotrasparenza, spark-free ATEX, inerzia chimica.",
        "Manutenzione quantificata: piano ispettivo e costi annui espliciti (~2,5–3,5% del capex).",
      ],
      weak_t: "Criticità da presidiare",
      weak: [
        "Modulo E ≈ 25.000 MPa (~1/8 dell'acciaio): oltre i 6 m servono controventi in Kevlar o telaio chiuso.",
        "Freccia di 21,3 cm a 6 m (~L/28): fuori dai limiti di esercizio senza palo ad alto modulo.",
        "Efficacia degli additivi NIR e della stabilizzazione UV da validare con prove di campo.",
        "Resistenza all'impatto cinetico di droni FPV non calcolata: richiede prove balistiche dedicate.",
      ],
      verdict_t: "Verdetto",
      verdict: "Fattibile: stabile fino a 4 m, praticabile a 6–8 m con i presidi strutturali già previsti dal progetto (telaio chiuso riduce la freccia >70%). Da completare con prove d'impatto e certificazioni NIR/ATEX.",
    },
    lifecycle: {
      index: "[05]",
      title: "Durabilità & costi",
      lead: "Vita operativa 25–30 anni (ISO 4892), assorbimento d'acqua <0,1%, inerte a idrocarburi e cloro, spark-free per zone ATEX 1 e 2.",
      table_head: ["Macro-attività", "Frequenza"],
      table_rows: [
        ["Ispezione strutturale PRFV", "Trimestrale"],
        ["Taratura e test fibra ottica", "Semestrale"],
        ["Lavaggio stealth specializzato", "Annuale"],
        ["Audit sicurezza (ATEX / Radar)", "Annuale"],
        ["Fondo ricambi consumabili", "Continuo"],
      ],
      note: "Piano di manutenzione per 1 km lineare di protezione — circa il 2,5–3,5% del costo di installazione per anno.",
    },
    contact: {
      index: "[06]",
      title: "Richiedi il brief tecnico",
      lead: "Documentazione completa, calcoli strutturali e scheda materiali disponibili per enti istituzionali e operatori di infrastrutture critiche — anche sotto NDA.",
      name: "Nome e cognome",
      org: "Ente / Organizzazione",
      email: "Email istituzionale",
      message: "Messaggio",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      ok: "Richiesta ricevuta. Rispondiamo entro 48 ore.",
      err: "Errore di invio. Riprova.",
    },
    pdf_btn: "Dossier PDF",
    pdf_busy: "Generazione…",
    chart: {
      title: "Freccia in cima in funzione dell'altezza",
      unit: "Freccia",
      limit: "Limite di esercizio indicativo ~ 5 cm",
    },
    lines_details_label: "Apri scheda tecnica",
    detail: {
      back: "Torna al pitch",
      sheet: "Scheda tecnica completa",
      common_t: "Dotazione comune a tutte le linee",
      cta: "Richiedi il brief per questa linea",
      common: [
        "Pali pultrusi PRFV Ø 100 mm × 5 mm, pigmentazione integrale nero opaco RAL 7016",
        "Additivi NIR 850–940 nm e bassa inerzia termica: invisibile a ottiche e FLIR",
        "Allarme a fibra ottica Ø 1,8–2,2 mm con localizzazione ± 5 m",
        "Integrazione VMS (ONVIF Profile M) e drone di pattuglia < 15 s",
        "Bulloneria e giunti in Nylon rinforzato o Kevlar, zero metallo",
        "Vita utile 25–30 anni (ISO 4892), manutenzione −90% vs recinzioni metalliche",
      ],
    },
    lineDetails: [
      {
        tag: "Linea 1",
        title: "Gabbia 3D — Fabbricati & depositi",
        img: "/images/line1_cage.png",
        intro: "Prevenire l'impatto di droni FPV kamikaze su obiettivi statici sensibili: depositi carburante, riserve idriche, fabbricati critici.",
        groups: [
          { t: "Configurazione strutturale", items: ["Gabbia tridimensionale completa: pareti verticali perimetrali + soffitto inclinato 15° per deflusso di pioggia e neve", "Stand-off minimo 5 m da cisterne e muri per dissipare l'onda d'urto di cariche esplosive", "Pali Ø 100 mm, altezza 8 m con telaio chiuso superiore: freccia ridotta oltre il 70%"] },
          { t: "Sistema a doppio stadio", items: ["Rete esterna sacrificale 40×40 mm, filo Ø 3,5 mm: trancia le eliche e fa detonare la carica a distanza di sicurezza", "Rete interna di contenimento 10×10 mm, filo Ø 1,5 mm ad alta tenacità: blocca frammenti e detriti secondari"] },
          { t: "Ambiente e sicurezza", items: ["Spark-free: nessuna scintilla meccanica in caso di impatto, idoneo a zone ATEX 1 e 2", "Resina epossidica/vinilestere inerte a benzina, gasolio, Jet A-1 e cloro", "Assorbimento d'acqua < 0,1%, nessuna corrosione galvanica né verniciature periodiche"] },
        ],
      },
      {
        tag: "Linea 2",
        title: "Corona radar — Antenne & TLC",
        img: "/images/line2_radar.png",
        intro: "Schermare fisicamente radar e antenne TLC senza alterare i lobi di radiazione elettromagnetica.",
        groups: [
          { t: "Configurazione strutturale", items: ["Recinzione perimetrale autoportante a corona, circolare o poligonale attorno al sensore", "Altezza variabile da 6 a 10 metri", "Sopra i 6 m: pultrusione ad alto modulo o controventi in Kevlar a 2/3 dell'altezza"] },
          { t: "Radiotrasparenza totale", items: ["Pali e reti in PRFV con tiranti in Kevlar: 100% amagnetici e dielettrici", "Il segnale radar attraversa la barriera senza distorsioni, echi fantasma o attenuazioni", "Maglia 25×25 mm a filo singolo continuo per minimizzare la sezione radar equivalente (RCS)"] },
          { t: "Mimetizzazione notturna", items: ["Rete integrata nel cono d'ombra radar sfruttando la radiotrasparenza", "Struttura posizionata seguendo la pendenza orografica del terreno", "Nero opaco RAL 7016: si confonde con lo sfondo scuro della vegetazione notturna"] },
        ],
      },
      {
        tag: "Linea 3",
        title: "Barriera lineare — Strade & viadotti",
        img: "/images/line3_highway.png",
        intro: "Barriera di protezione lineare focalizzata sui punti di strozzatura logistica: viadotti, ponti, gallerie.",
        groups: [
          { t: "Configurazione strutturale", items: ["Barriere verticali installate su viadotti, ponti e imbocchi delle gallerie", "Pali h 4 m autoportanti con braccio a sbalzo a L inclinato 45° verso l'esterno della carreggiata", "Freccia in cima ≈ 4,2 cm a 125 km/h di vento: entro i limiti elastici"] },
          { t: "Ancoraggio rapido", items: ["Basi con flange fessurate fissate meccanicamente sulle barriere New Jersey esistenti", "Tasselli chimici: nessuno scavo stradale, installazione rapida senza interruzione del traffico"] },
          { t: "Invisibilità e vento", items: ["Pali sul retro dell'illuminazione pubblica: la rete scompare nei coni d'ombra della luce stradale", "Maglia 30×30 mm flessibile, filo Ø 2 mm: superficie esposta 13%, coefficiente aerodinamico ~0,35", "Resiste alle correnti dei mezzi pesanti e ai venti trasversali sui viadotti"] },
        ],
      },
    ],
    owner: {
      label: "Project owner",
      name: "Fiberplast Srl",
      addr: "III Strada Consortile, ZI Macchiareddu, CP 187 — 09032 Assemini (CA)",
      email: "info@fiberplast.it",
    },
    galleryPage: {
      title: "Galleria notturna",
      hint: "← → naviga // ESC torna al pitch",
      captions: [
        "Perimetro stealth su sito industriale — invisibile di notte",
        "Gabbia 3D su deposito carburante — Linea 1",
        "Corona radar radiotrasparente — Linea 2",
        "Barriera lineare su viadotto — Linea 3",
        "Macro: pultruso PRFV Ø 100 mm e fibra ottica co-estrusa",
        "Vista termica: il drone vede il bersaglio, non la barriera",
      ],
    },
    footer: "SHADOW SHIELD — Progetto preliminare. Sistema di protezione passiva anti-drone in PRFV.",
  },
  en: {
    nav: {
      tech: "Technology",
      lines: "Product lines",
      alarm: "Alarm",
      verification: "Verification",
      lifecycle: "Lifecycle",
      contact: "Contact",
      cta: "Request brief",
      coords: "45.4642° N — 09.1900° E",
    },
    hero: {
      overline: "Passive anti-drone protection system // GFRP",
      line1: "SHADOW",
      line2: "SHIELD",
      sub: "Fiberglass poles and nets. Invisible to the eye, to thermal sensors and to radar: the physical barrier hostile drones never see coming.",
      stats: [
        { v: "0%", l: "Specular reflection" },
        { v: "25–30", l: "Years of service life" },
        { v: "−90%", l: "Maintenance costs" },
        { v: "<15s", l: "Patrol drone takeoff" },
      ],
      scroll: "Scroll for the brief",
    },
    marquee: "// SHADOW SHIELD // GFRP STEALTH BARRIER // THERMAL INVISIBILITY // RADAR-TRANSPARENT // ATEX SPARK-FREE // FIBER-OPTIC ALARM ",
    stealth: {
      index: "[01]",
      title: "Stealth Technology",
      lead: "Every component is engineered to disappear: matte black in the resin mass, near-infrared absorption, zero metal.",
      image_caption: "GFRP pultrusion Ø 100 mm — rough anti-glare finish",
      features: [
        { t: "Integral pigmentation", d: "Matte black / Anthracite Grey RAL 7016 blended into the resin before pultrusion. No painting, specular glint zeroed at 100%." },
        { t: "NIR absorption", d: "Nanostructured additives absorb drone night illuminators (850–940 nm) without reflecting them." },
        { t: "Thermal invisibility", d: "Extremely low thermal inertia: the structure matches air temperature and erases contrast in FLIR viewers." },
        { t: "Zero metal", d: "Bolts and joints in reinforced Nylon or Kevlar. No reflective or conductive components." },
      ],
    },
    lines: {
      index: "[02]",
      title: "Three lines, one system",
      lead: "Purpose-built configurations for each critical asset — not a generic fence.",
      items: [
        { tag: "Line 1", t: "3D Cage — Buildings & depots", img: "/images/line1_cage.png", specs: ["5 m stand-off to dissipate blast waves", "Dual mesh: 40×40 mm sacrificial + 10×10 mm containment", "15° sloped roof for rain and snow runoff", "Stops FPV kamikaze drones on tanks and buildings"] },
        { tag: "Line 2", t: "Radar ring — Antennas & TLC", img: "/images/line2_radar.png", specs: ["Total radio transparency: 100% non-magnetic, dielectric", "6–10 m height, circular crown fence", "25×25 mm continuous-wire mesh, minimal RCS", "No ghost echoes on radiation lobes"] },
        { tag: "Line 3", t: "Linear barrier — Roads & viaducts", img: "/images/line3_highway.png", specs: ["Cantilevered L-arm tilted 45° outward", "Anchored to New Jersey barriers, zero excavation", "30×30 mm wind-shedding mesh, low sail effect", "Invisible in the shadow cones of street lighting"] },
      ],
    },
    alarm: {
      index: "[03]",
      title: "Invisible fiber-optic alarm",
      lead: "A 1.8–2.2 mm sensor cable woven into the mesh detects cutting, lifting and impact — without compromising stealth.",
      points: [
        { t: "± 5 m localization", d: "OTDR/APASS analyzer turns micro-deformations into precise coordinates on the GIS map." },
        { t: "EM immunity", d: "Dielectric fiber: zero interference with radar and EM fields." },
        { t: "VMS integration", d: "ONVIF Profile M / native SDK: Milestone, Genetec, Avigilon. Automatic slewing of thermal PTZ cameras." },
        { t: "Automatic countermeasure", d: "MAVLink/REST alert to a Drone-in-a-Box station: takeoff in under 15 seconds and thermal tracking of the intruder." },
      ],
    },
    verification: {
      index: "[04]",
      title: "Technical verification",
      lead: "Independent review of the preliminary document's structural calculations (design wind 750 N/m² ≈ 125 km/h, 4 m pole spacing).",
      table_head: ["Height", "Base load", "Max moment", "Tip deflection", "Status"],
      table_rows: [
        ["4 m — Roads", "≈ 4,560 N", "9,120 Nm", "≈ 4.2 cm", "Stable, self-supporting"],
        ["6 m — Radar", "≈ 6,840 N", "20,520 Nm", "≈ 21.3 cm", "Borderline: stiffening required"],
        ["8 m — Cages", "≈ 9,120 N", "36,480 Nm", "≈ 67.5 cm", "Unstable without closed frame"],
      ],
      strengths_t: "Strengths",
      strengths: [
        "Internally consistent math: loads, moments and deflections check out.",
        "Asset-based segmentation: three targeted configurations instead of a generic solution.",
        "Intrinsic GFRP advantages: radio transparency, ATEX spark-free, chemical inertness.",
        "Quantified maintenance: explicit inspection plan and annual costs (~2.5–3.5% of capex).",
      ],
      weak_t: "Criticalities to address",
      weak: [
        "Elastic modulus E ≈ 25,000 MPa (~1/8 of steel): above 6 m Kevlar bracing or a closed frame is mandatory.",
        "21.3 cm deflection at 6 m (~L/28): beyond serviceability limits without a high-modulus pole.",
        "NIR additive effectiveness and UV stabilization must be validated with field testing.",
        "Kinetic impact resistance against FPV drones is not calculated: dedicated ballistic tests required.",
      ],
      verdict_t: "Verdict",
      verdict: "Feasible: stable up to 4 m, workable at 6–8 m with the structural measures already specified (closed frame cuts deflection by >70%). To be completed with impact testing and NIR/ATEX certification.",
    },
    lifecycle: {
      index: "[05]",
      title: "Durability & costs",
      lead: "25–30 year service life (ISO 4892), water absorption <0.1%, inert to hydrocarbons and chlorine, spark-free for ATEX zones 1 and 2.",
      table_head: ["Activity", "Frequency"],
      table_rows: [
        ["GFRP structural inspection", "Quarterly"],
        ["Fiber-optic calibration & testing", "Half-yearly"],
        ["Specialized stealth washing", "Yearly"],
        ["Safety audit (ATEX / Radar)", "Yearly"],
        ["Consumable spares fund", "Ongoing"],
      ],
      note: "Maintenance plan for 1 linear km of protection — roughly 2.5–3.5% of installation cost per year.",
    },
    contact: {
      index: "[06]",
      title: "Request the technical brief",
      lead: "Full documentation, structural calculations and material datasheets available to institutional bodies and critical infrastructure operators — NDA supported.",
      name: "Full name",
      org: "Authority / Organization",
      email: "Institutional email",
      message: "Message",
      submit: "Send request",
      sending: "Sending…",
      ok: "Request received. We reply within 48 hours.",
      err: "Submission error. Please retry.",
    },
    pdf_btn: "PDF Dossier",
    pdf_busy: "Generating…",
    chart: {
      title: "Tip deflection vs pole height",
      unit: "Deflection",
      limit: "Indicative serviceability limit ~ 5 cm",
    },
    lines_details_label: "Open technical sheet",
    detail: {
      back: "Back to the pitch",
      sheet: "Full technical sheet",
      common_t: "Equipment common to all lines",
      cta: "Request the brief for this line",
      common: [
        "Pultruded GFRP poles Ø 100 mm × 5 mm, integral matte black RAL 7016 pigmentation",
        "NIR additives 850–940 nm and low thermal inertia: invisible to optics and FLIR",
        "Fiber-optic alarm Ø 1.8–2.2 mm with ± 5 m localization",
        "VMS integration (ONVIF Profile M) and patrol drone < 15 s",
        "Bolts and joints in reinforced Nylon or Kevlar, zero metal",
        "25–30 year service life (ISO 4892), maintenance −90% vs metal fencing",
      ],
    },
    lineDetails: [
      {
        tag: "Line 1",
        title: "3D Cage — Buildings & depots",
        img: "/images/line1_cage.png",
        intro: "Prevent FPV kamikaze drone impacts on static sensitive targets: fuel depots, water reserves, critical buildings.",
        groups: [
          { t: "Structural configuration", items: ["Full three-dimensional cage: vertical perimeter walls + 15° sloped roof for rain and snow runoff", "Minimum 5 m stand-off from tanks and walls to dissipate explosive blast waves", "Ø 100 mm poles, 8 m height with closed upper frame: deflection reduced by over 70%"] },
          { t: "Dual-stage system", items: ["Sacrificial outer mesh 40×40 mm, Ø 3.5 mm wire: shreds propellers and detonates the charge at safe distance", "Containment inner mesh 10×10 mm, Ø 1.5 mm high-tenacity wire: stops fragments and secondary debris"] },
          { t: "Environment & safety", items: ["Spark-free: no mechanical sparks on impact, suitable for ATEX zones 1 and 2", "Epoxy/vinylester resin inert to gasoline, diesel, Jet A-1 and chlorine", "Water absorption < 0.1%, no galvanic corrosion or periodic repainting"] },
        ],
      },
      {
        tag: "Line 2",
        title: "Radar ring — Antennas & TLC",
        img: "/images/line2_radar.png",
        intro: "Physically shield radar and telecom antennas without altering electromagnetic radiation lobes.",
        groups: [
          { t: "Structural configuration", items: ["Self-supporting perimeter crown fence, circular or polygonal around the sensor", "Variable height from 6 to 10 metres", "Above 6 m: high-modulus pultrusion or Kevlar bracing at 2/3 of the height"] },
          { t: "Total radio transparency", items: ["GFRP poles and nets with Kevlar stays: 100% non-magnetic and dielectric", "The radar signal crosses the barrier without distortion, ghost echoes or attenuation", "25×25 mm continuous single-wire mesh to minimize radar cross-section (RCS)"] },
          { t: "Night camouflage", items: ["Mesh integrated within the radar shadow cone, exploiting radio transparency", "Structure positioned following the orographic slope of the terrain", "Matte black RAL 7016: blends into the dark background of night vegetation"] },
        ],
      },
      {
        tag: "Line 3",
        title: "Linear barrier — Roads & viaducts",
        img: "/images/line3_highway.png",
        intro: "Linear protection barrier focused on logistical chokepoints: viaducts, bridges, tunnel entrances.",
        groups: [
          { t: "Structural configuration", items: ["Vertical barriers installed on viaducts, bridges and tunnel entrances", "4 m self-supporting poles with cantilevered L-arm tilted 45° outward from the roadway", "Tip deflection ~ 4.2 cm at 125 km/h wind: within elastic limits"] },
          { t: "Rapid anchoring", items: ["Slotted-flange bases mechanically fixed to existing New Jersey barriers", "Chemical anchors: no road excavation, fast installation without traffic interruption"] },
          { t: "Invisibility & wind", items: ["Poles behind street lighting: the mesh disappears in the light shadow cones", "30×30 mm flexible mesh, Ø 2 mm wire: 13% exposed surface, ~0.35 drag coefficient", "Withstands heavy-vehicle air currents and crosswinds on viaducts"] },
        ],
      },
    ],
    owner: {
      label: "Project owner",
      name: "Fiberplast Srl",
      addr: "III Strada Consortile, ZI Macchiareddu, CP 187 - 09032 Assemini (CA), Italy",
      email: "info@fiberplast.it",
    },
    galleryPage: {
      title: "Night gallery",
      hint: "← → navigate // ESC back to the pitch",
      captions: [
        "Stealth perimeter on an industrial site — invisible at night",
        "3D cage over a fuel depot — Line 1",
        "Radar-transparent antenna ring — Line 2",
        "Linear barrier on a viaduct — Line 3",
        "Macro: Ø 100 mm GFRP pultrusion and co-extruded fiber optic",
        "Thermal view: the drone sees the target, not the barrier",
      ],
    },
    footer: "SHADOW SHIELD — Preliminary project. Passive anti-drone GFRP protection system.",
  },
  ar: {
    nav: {
      tech: "التقنية",
      lines: "الخطوط",
      alarm: "الإنذار",
      verification: "التحقق",
      lifecycle: "دورة الحياة",
      contact: "اتصل بنا",
      cta: "اطلب الملف الفني",
      coords: "45.4642° N — 09.1900° E",
    },
    hero: {
      overline: "نظام حماية سلبي مضاد للطائرات المسيّرة // PRFV",
      line1: "SHADOW",
      line2: "SHIELD",
      sub: "أعمدة وشبكات من الألياف الزجاجية. غير مرئية للعين ولأجهزة التصوير الحراري وللرادار: الحاجز المادي الذي لا تراه الطائرات المسيّرة المعادية قادمًا.",
      stats: [
        { v: "0%", l: "انعكاس مرآوي" },
        { v: "25–30", l: "سنة من العمر التشغيلي" },
        { v: "−90%", l: "تكاليف الصيانة" },
        { v: "<15s", l: "إقلاع طائرة الدورية" },
      ],
      scroll: "مرّر للاطلاع على الملف",
    },
    marquee: "// SHADOW SHIELD // حاجز تخفٍّ من PRFV // تخفٍّ حراري // شفافية رادارية // ATEX بدون شرر // إنذار بالألياف الضوئية ",
    stealth: {
      index: "[01]",
      title: "تقنية التخفي",
      lead: "كل مكوّن مصمم ليختفي: أسود مطفي في كتلة الراتنج، امتصاص للأشعة تحت الحمراء القريبة، صفر معدن.",
      image_caption: "بثق PRFV بقطر 100 مم — تشطيب خشن مضاد للانعكاس",
      features: [
        { t: "صبغة مدمجة", d: "أسود مطفي / رمادي أنثراسيت RAL 7016 ممزوج في الراتنج قبل البثق. بدون دهان، انعكاس مرآوي معدوم 100%." },
        { t: "امتصاص الأشعة تحت الحمراء", d: "إضافات نانوية تمتص أجهزة الإضاءة الليلية للطائرات المسيّرة (850–940 نانومتر) دون عكسها." },
        { t: "التخفي الحراري", d: "قصور حراري منخفض جدًا: تتبع البنية درجة حرارة الهواء المحيط فتلغي التباين في أجهزة FLIR." },
        { t: "صفر معدن", d: "براغي ووصلات من النايلون المقوى أو الكيفلار. لا مكونات عاكسة أو موصلة." },
      ],
    },
    lines: {
      index: "[02]",
      title: "ثلاثة خطوط، نظام واحد",
      lead: "تكوينات مصممة لكل أصل حيوي — وليس سياجًا عامًا.",
      items: [
        { tag: "الخط 1", t: "قفص ثلاثي الأبعاد — المباني والمستودعات", img: "/images/line1_cage.png", specs: ["مسافة أمان 5 أمتار لتبديد موجة الانفجار", "شبكة مزدوجة: 40×40 مم تضحية + 10×10 مم احتواء", "سقف مائل 15° لتصريف الأمطار والثلوج", "يوقف طائرات FPV الانتحارية عن الصهاريج والمباني"] },
        { tag: "الخط 2", t: "حلقة رادارية — الهوائيات والاتصالات", img: "/images/line2_radar.png", specs: ["شفافية رادارية كاملة: غير مغناطيسية وعازلة 100%", "ارتفاع 6–10 أمتار، سياج دائري حلقي", "شبكة 25×25 مم بسلك مستمر، مقطع راداري أدنى", "لا أصداء وهمية على فصوص الإشعاع"] },
        { tag: "الخط 3", t: "حاجز خطي — الطرق والجسور", img: "/images/line3_highway.png", specs: ["ذراع كابولي على شكل L مائل 45° نحو الخارج", "تثبيت على حواجز نيو جيرسي، بدون حفريات", "شبكة 30×30 مم مقاومة للرياح، تأثير شراعي منخفض", "غير مرئية في مخاريط ظل الإنارة العامة"] },
      ],
    },
    alarm: {
      index: "[03]",
      title: "إنذار بالألياف الضوئية غير مرئي",
      lead: "كابل استشعار بقطر 1.8–2.2 مم منسوج في الشبكة يكشف القطع والرفع والاصطدام — دون المساس بالتخفي.",
      points: [
        { t: "تحديد الموقع بدقة ± 5 م", d: "محلل OTDR/APASS يحوّل التشوهات الدقيقة إلى إحداثيات دقيقة على خريطة GIS." },
        { t: "مناعة كهرومغناطيسية", d: "ألياف عازلة: صفر تداخل مع الرادار والحقول الكهرومغناطيسية." },
        { t: "تكامل مع أنظمة VMS", d: "ONVIF Profile M / SDK أصلي: Milestone وGenetec وAvigilon. توجيه تلقائي لكاميرات PTZ الحرارية." },
        { t: "تدابير مضادة تلقائية", d: "تنبيه MAVLink/REST لمحطة Drone-in-a-Box: إقلاع في أقل من 15 ثانية وتتبع حراري للمتسلل." },
      ],
    },
    verification: {
      index: "[04]",
      title: "التحقق الفني",
      lead: "مراجعة مستقلة للحسابات الإنشائية في الوثيقة الأولية (رياح التصميم 750 نيوتن/م² ≈ 125 كم/س، تباعد الأعمدة 4 أمتار).",
      table_head: ["الارتفاع", "الحمل عند القاعدة", "العزم الأقصى", "انحراف القمة", "الحالة"],
      table_rows: [
        ["4 م — الطرق", "≈ 4.560 N", "9.120 Nm", "≈ 4,2 cm", "مستقر، ذاتي الحمل"],
        ["6 م — الرادار", "≈ 6.840 N", "20.520 Nm", "≈ 21,3 cm", "عند الحد: يتطلب تصليبًا"],
        ["8 م — الأقفاص", "≈ 9.120 N", "36.480 Nm", "≈ 67,5 cm", "غير مستقر بدون إطار مغلق"],
      ],
      strengths_t: "نقاط القوة",
      strengths: [
        "حسابات متسقة داخليًا: الأحمال والعزوم والانحرافات متطابقة رياضيًا.",
        "تقسيم حسب الأصول: ثلاثة تكوينات موجهة بدلاً من حل عام.",
        "مزايا جوهرية لمادة PRFV: شفافية رادارية، بدون شرر ATEX، خمول كيميائي.",
        "صيانة محددة كميًا: خطة فحص وتكاليف سنوية واضحة (~2.5–3.5% من الإنفاق الرأسمالي).",
      ],
      weak_t: "نقاط حرجة تتطلب معالجة",
      weak: [
        "معامل المرونة E ≈ 25.000 ميغاباسكال (~1/8 الفولاذ): فوق 6 أمتار يلزم تدعيم بالكيفلار أو إطار مغلق.",
        "انحراف 21.3 سم عند 6 أمتار (~L/28): خارج حدود التشغيل دون عمود عالي المعامل.",
        "فعالية إضافات NIR والتثبيت ضد الأشعة فوق البنفسجية تتطلب تحققًا ميدانيًا.",
        "مقاومة الاصطدام الحركي لطائرات FPV غير محسوبة: تتطلب اختبارات بالستية مخصصة.",
      ],
      verdict_t: "الخلاصة",
      verdict: "مجدٍ فنيًا: مستقر حتى 4 أمتار، وقابل للتنفيذ عند 6–8 أمتار مع الإجراءات الإنشائية المنصوص عليها في المشروع (الإطار المغلق يخفض الانحراف >70%). يُستكمل باختبارات الاصطدام وشهادات NIR/ATEX.",
    },
    lifecycle: {
      index: "[05]",
      title: "المتانة والتكاليف",
      lead: "عمر تشغيلي 25–30 سنة (ISO 4892)، امتصاص ماء <0.1%، خمول تجاه الهيدروكربونات والكلور، بدون شرر لمناطق ATEX 1 و2.",
      table_head: ["النشاط", "الوتيرة"],
      table_rows: [
        ["فحص إنشائي لهياكل PRFV", "فصلي"],
        ["معايرة واختبار الألياف الضوئية", "نصف سنوي"],
        ["غسل متخصص للحفاظ على التخفي", "سنوي"],
        ["تدقيق السلامة (ATEX / رادار)", "سنوي"],
        ["صندوق قطع الغيار الاستهلاكية", "مستمر"],
      ],
      note: "خطة صيانة لكل كيلومتر خطي من الحماية — نحو 2.5–3.5% من تكلفة التركيب سنويًا.",
    },
    contact: {
      index: "[06]",
      title: "اطلب الملف الفني",
      lead: "الوثائق الكاملة والحسابات الإنشائية وبطاقات المواد متاحة للهيئات الحكومية ومشغلي البنية التحتية الحيوية — مع دعم اتفاقيات عدم الإفصاح.",
      name: "الاسم الكامل",
      org: "الجهة / المنظمة",
      email: "البريد الإلكتروني المؤسسي",
      message: "الرسالة",
      submit: "إرسال الطلب",
      sending: "جارٍ الإرسال…",
      ok: "تم استلام الطلب. نرد خلال 48 ساعة.",
      err: "خطأ في الإرسال. حاول مجددًا.",
    },
    footer: "SHADOW SHIELD — مشروع أولي. نظام حماية سلبي مضاد للطائرات المسيّرة من PRFV.",
    pdf_btn: "ملف PDF",
    pdf_busy: "جارٍ الإنشاء…",
    chart: {
      title: "انحراف القمة حسب ارتفاع العمود",
      unit: "الانحراف",
      limit: "حد التشغيل الاسترشادي ~ 5 سم",
    },
    lines_details_label: "افتح البطاقة الفنية",
    detail: {
      back: "العودة إلى العرض",
      sheet: "البطاقة الفنية الكاملة",
      common_t: "تجهيزات مشتركة بين جميع الخطوط",
      cta: "اطلب الملف الفني لهذا الخط",
      common: [
        "أعمدة PRFV مقذوفة Ø 100 مم × 5 مم، صبغة مدمجة أسود مطفي RAL 7016",
        "إضافات NIR 850–940 نانومتر وقصور حراري منخفض: غير مرئي للبصريات وFLIR",
        "إنذار بالألياف الضوئية Ø 1.8–2.2 مم مع تحديد موقع ± 5 م",
        "تكامل VMS (ONVIF Profile M) وطائرة دورية < 15 ثانية",
        "براغي ووصلات من النايلون المقوى أو الكيفلار، صفر معدن",
        "عمر تشغيلي 25–30 سنة (ISO 4892)، صيانة −90% مقارنة بالأسيجة المعدنية",
      ],
    },
    lineDetails: [
      {
        tag: "الخط 1",
        title: "قفص ثلاثي الأبعاد — المباني والمستودعات",
        img: "/images/line1_cage.png",
        intro: "منع اصطدام طائرات FPV الانتحارية بالأهداف الثابتة الحساسة: مستودعات الوقود وخزانات المياه والمباني الحيوية.",
        groups: [
          { t: "التكوين الإنشائي", items: ["قفص ثلاثي الأبعاد كامل: جدران عمودية محيطية + سقف مائل 15° لتصريف المطر والثلج", "مسافة أمان لا تقل عن 5 أمتار من الصهاريج والجدران لتبديد موجة انفجار الشحنات", "أعمدة بقطر 100 مم، ارتفاع 8 أمتار مع إطار علوي مغلق: انخفاض الانحراف بأكثر من 70%"] },
          { t: "نظام مزدوج المراحل", items: ["شبكة خارجية تضحية 40×40 مم، سلك بقطر 3.5 مم: تقطع المراوح وتفجّر الشحنة على مسافة آمنة", "شبكة داخلية للاحتواء 10×10 مم، سلك بقطر 1.5 مم عالي المتانة: توقف الشظايا والحطام الثانوي"] },
          { t: "البيئة والسلامة", items: ["بدون شرر: لا شرر ميكانيكي عند الاصطدام، مناسب لمناطق ATEX 1 و2", "راتنج إيبوكسي/فينيل إستر خامل تجاه البنزين والديزل وJet A-1 والكلور", "امتصاص ماء < 0.1%، لا تآكل جلفاني ولا إعادة دهان دورية"] },
        ],
      },
      {
        tag: "الخط 2",
        title: "حلقة رادارية — الهوائيات والاتصالات",
        img: "/images/line2_radar.png",
        intro: "حماية الرادارات وهوائيات الاتصالات ماديًا دون تغيير فصوص الإشعاع الكهرومغناطيسي.",
        groups: [
          { t: "التكوين الإنشائي", items: ["سياج محيطي ذاتي الحمل على شكل حلقة دائرية أو مضلعة حول المستشعر", "ارتفاع متغير من 6 إلى 10 أمتار", "فوق 6 أمتار: بثق عالي المعامل أو تدعيم بالكيفلار عند ثلثي الارتفاع"] },
          { t: "شفافية رادارية كاملة", items: ["أعمدة وشبكات من PRFV مع شدّادات كيفلار: غير مغناطيسية وعازلة 100%", "تعبر إشارة الرادار الحاجز دون تشوهات أو أصداء وهمية أو توهين", "شبكة 25×25 مم بسلك واحد مستمر لتقليل المقطع الراداري (RCS)"] },
          { t: "التمويه الليلي", items: ["شبكة مدمجة في مخروط ظل الرادار باستغلال الشفافية الرادارية", "البنية موضوعة باتباع انحدار التضاريس", "أسود مطفي RAL 7016: يندمج مع الخلفية الداكنة للغطاء النباتي الليلي"] },
        ],
      },
      {
        tag: "الخط 3",
        title: "حاجز خطي — الطرق والجسور",
        img: "/images/line3_highway.png",
        intro: "حاجز حماية خطي يركز على نقاط الاختناق اللوجستية: الجسور والمعابر العلوية ومداخل الأنفاق.",
        groups: [
          { t: "التكوين الإنشائي", items: ["حواجز عمودية على الجسور والمعابر العلوية ومداخل الأنفاق", "أعمدة بارتفاع 4 أمتار ذاتية الحمل مع ذراع كابولي L مائلة 45° نحو خارج الطريق", "انحراف القمة ~ 4.2 سم عند رياح 125 كم/س: ضمن الحدود المرنة"] },
          { t: "التثبيت السريع", items: ["قواعد بفلنجات مثبتة ميكانيكيًا على حواجز نيو جيرسي القائمة", "ركائز كيميائية: لا حفر في الطريق، تركيب سريع دون إيقاف الحركة"] },
          { t: "التخفي والرياح", items: ["أعمدة خلف الإنارة العامة: تختفي الشبكة في مخاريط ظل الإنارة", "شبكة 30×30 مم مرنة، سلك بقطر 2 مم: سطح مكشوف 13%، معامل سحب ~0.35", "تقاوم تيارات الشاحنات الثقيلة والرياح الجانبية على الجسور"] },
        ],
      },
    ],
    owner: {
      label: "مالك المشروع",
      name: "Fiberplast Srl",
      addr: "III Strada Consortile, ZI Macchiareddu, CP 187 — 09032 Assemini (CA)",
      email: "info@fiberplast.it",
    },
    galleryPage: {
      title: "المعرض الليلي",
      hint: "← → للتنقل // ESC للعودة",
      captions: [
        "محيط متخفٍّ على موقع صناعي — غير مرئي ليلًا",
        "قفص ثلاثي الأبعاد فوق مستودع وقود — الخط 1",
        "حلقة هوائيات شفافة راداريًا — الخط 2",
        "حاجز خطي على جسر — الخط 3",
        "لقطة مقربة: بثق PRFV Ø 100 مم وألياف ضوئية مدمجة",
        "رؤية حرارية: ترى الطائرة الهدف، لا الحاجز",
      ],
    },
  },
};
